import React, { useContext, useEffect, useState } from "react";
import Navigasi from "../../components/Navigasi";
import { io } from "socket.io-client";
import Contact from "../../components/complain/Contact";
import Chat from "../../components/complain/Chat";
import { UserContext } from "../../context/userContext";

let socket;

function Complain() {
  document.title = "Complain User";
  const [contact, setContact] = useState(null);
  const [contacts, setContacts] = useState([]);
  const [messages, setMessages] = useState([]);
  const [state, dispatch] = useContext(UserContext);

  useEffect(() => {
    socket = io("https://dumbmerch-aldi.herokuapp.com", {
      auth: {
        token: localStorage.getItem("token"),
      },
      query: {
        id: state.user.id,
      },
    });

    socket.on("new message", () => {
      console.log("contact", contact);
      console.log("triggered", contact?.id);
      socket.emit("load messages", contact?.id);
    });

    loadContacts();
    loadMessages();

    socket.on("connect_error", (err) => {
      console.error(err.message); // not authorized
    });

    return () => {
      socket.disconnect();
    };
  }, [messages]);

  const loadContacts = () => {
    socket.emit("load admin contact");

    socket.on("admin contact", (data) => {
      let dataContact = data.filter(
        (item) =>
          item.status !== "admin" &&
          (item.recipientMessage.length > 0 || item.senderMessage.length > 0)
      );

      dataContact = data.map((item) => ({
        ...item,
        message: "Click here to start message",
      }));

      setContacts(dataContact);
    });
  };

  const loadMessages = (value) => {
    // socket.on("admin contact", (data) => {
    socket.on("messages", (data) => {
      if (data.length > 0) {
        const dataMessages = data.map((item) => ({
          idSender: item.sender.id,
          message: item.message,
        }));
        console.log(dataMessages);
        setMessages(dataMessages);
      }
      loadContacts();
      const chatMessages = document.getElementById("chat-messages");
      chatMessages.scrollTop = chatMessages?.scrollHeight;
    });
    // });
  };

  const onSendMessage = (e) => {
    if (e.key === "Enter") {
      const data = {
        idRecipient: contact.id,
        message: e.target.value,
      };

      socket.emit("send messages", data);
      e.target.value = "";
    }
  };

  const onClickContact = (data) => {
    setContact(data);
    socket.emit("load messages", data.id);
  };

  return (
    <>
      <Navigasi active="complain-user" />
      <div className="container complain-section my-5">
        <div className="row">
          <div className="col-md-4 chat-list">
            <Contact
              dataContact={contacts}
              clickContact={onClickContact}
              contact={contact}
            />
            {/* <div className="row row-chat-section">
              <div className="col-md-2">
                <img src={chatImg} alt="avatar" />
              </div>
              <div className="col-md-10">
                <span className="name-account">Admin</span>
                <span className="message-account text-secondary fw-bold">
                  Yes, Is there anything I can help
                </span>
              </div>
            </div> */}
          </div>
          <div className="col-md-8 px-3 d-flex align-items-end">
            <div className="row w-100 mx-auto">
              <Chat
                contact={contact}
                messages={messages}
                user={state.user}
                sendMessage={onSendMessage}
              />
              {/* <div className="row mb-5 d-flex justify-content-end">
                <div className="col-md-6">
                  <div className="card bg-dark p-3 text-center">
                    Hello Admin, I Need Your Help
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1 d-flex justify-content-center align-items-end">
                  <img src={chatImg} alt="avatar" />
                </div>
                <div className="col-md-7">
                  <div className="card bg-dark p-3">
                    Yes, Is there anything I can help
                  </div>
                </div>
              </div>
              <input
                type="text"
                className="form-control bg-dark mt-5 text-white"
                placeholder="Send Message..."
              /> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Complain;
